import { createRouter, createWebHistory } from "vue-router";
import Swal from "sweetalert2";
import HomeView from "../views/HomeView.vue";
import login from "../views/login.vue";
import choose from "../views/choose.vue";
import change_pw from "../views/change_pw.vue";
import basic_info from "../views/basic_info.vue";

const routes = [
  {
    path: "/main",
    name: "main",
    component: HomeView,
  },
  {
    path: "/",
    name: "login",
    component: login,
  },
  {
    path: "/choose",
    name: "choose",
    component: choose,
  },
  {
    path: "/change_pw",
    name: "change_pw",
    component: change_pw,
  },
  {
    path: "/basic_info",
    name: "basic_info",
    component: basic_info,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const sg = localStorage.getItem("school_guid");
  const ac = localStorage.getItem("ac");
  const token = localStorage.getItem("token");
  const level = localStorage.getItem("level");
  const choose = localStorage.getItem("choose");

  // 檢查是否登入
  if (!sg || !ac || !token) {
    if (to.name !== "login") {
      try {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: "Not logged in.",
        });
        next("/login");
      } catch (error) {
        next("/login");
      }
    } else {
      next();
    }
  } else {
    // 已登入後，檢查 level 和 choose
    if (to.name !== "login" && to.name !== "choose" && !level) {
      if (!level || !choose) {
        if (to.name !== "choose") {
          try {
            await Swal.fire({
              icon: "error",
              title: "Error",
              text: "A level selection is required to continue.",
            });
            next("/choose");
          } catch (error) {
            next("/choose");
          }
        } else {
          next();
        }
      } else {
        next();
      }
    }else{
      next();
    }
  }
});

export default router;
